import React, { useState, useEffect, useRef } from 'react';
import { Input, Radio, Button } from '../../Forms/Forms'
import fetchApiData from '../../../apiHandlers/fetchApiData';
import CONSTANTS from '../../../Constants'
import { useDispatch, useSelector } from 'react-redux';
import { setVeiculeInfos, setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore } from '../../../redux-files/actions/action';
import { useNavigate } from 'react-router-dom';
import { pushEventToGTM } from '../../../helpers/trackerManager';

const SerieNumberTab = () => {
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const [contratService, setContratService] = useState(vehicleInfo.contratService || false) 
    const [isLoading, setIsLoading] = useState(false)
    const [serieNumberInput, setSerieNumberInput] = useState(vehicleInfo.SerialNumber)
    const [serieNumberErrorLabel, setSerieNumberErrorLabel] = useState('')
    const [showInfoDetail, setShowInfoDetail] = useState(false)
    const [kilometrageState, setkilometrageState] = useState({ kilometrageInput: vehicleInfo.Mileage || '', kilometrageErrorLabel: '', })
    const { kilometrageInput, kilometrageErrorLabel } = kilometrageState
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const myRef = useRef()
    const handleClickOutside = (e, myRef) => {
        if (myRef.current && !myRef.current.contains(e.target)) {
            setShowInfoDetail(false)
        }
    }
    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", (e) => handleClickOutside(e, myRef));
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", (e) => handleClickOutside(e, myRef));
        };
    }, [])

    const checkSerieNumber = () => {
        const seriNumberAPI = new fetchApiData()
        setIsLoading(true)
        seriNumberAPI.getSerieNumber(serieNumberInput)
            .then(
                data => {
                    if (data.d.ErrorCode === 0) {
                        setIsLoading(false)
                        setSerieNumberErrorLabel('')
                        if (vehicleInfo.ModelCode !== data.d.VehicleInfo.ModelCode || vehicleInfo.MotorCode !== data.d.VehicleInfo.MotorCode) {
                            storeSelectedOperations.forEach(operation => {
                                if (!operation.interventionForfaits[0].isConstructeur) {
                                    operation.interventionForfaits[0].SubFunctionList[0].ForfaitList.forEach(forfait => forfait.isChecked = false)
                                }
                            })
                            dispatch(setSelectedForfaitsToStore([]))
                            dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
                        }
                        dispatch(setVeiculeInfos({ ...data.d.VehicleInfo, Mileage: kilometrageInput, tabNumber: '2', contratService: contratService }))
                        navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
                        // this.isRecallCampagneActivate && this.checkCompagneRappelEligibility()
                        // !this.isRecallCampagneActivate && !this.isfiltersPopinOpen && this.props.CurrentStepSetAction(4)
                        pushEventToGTM({
                            pageName: 'car-details',
                            eventAction: 'Redirection::Internal::Next_step',
                            eventLabel: 'vin',
                            eventCategory: 'content'
                        })
                    }
                    else {
                        setSerieNumberErrorLabel((data.d.ErrorMessage == 1 ? CONSTANTS.LABELS.vehicule_serial_step1_error_incorrect : CONSTANTS.LABELS.vehicule_serial_step1_error_unknown))
                        setIsLoading(false)
                    }
                })
            .catch(Error => {
                console.log('fait: ', Error)
                setSerieNumberErrorLabel('error')
                setIsLoading(false)
            })
    };
    const dislayVinHelp = () => {
        setShowInfoDetail(prev => !prev)
        pushEventToGTM({
            pageName: 'car-details',
            eventAction: 'Display::Help',
            eventLabel: CONSTANTS.LABELS.vehicule_serial_step1_help1,
            eventCategory: 'content'
        })
    }
    const LoadingClass = (isLoading ? " Loading" : "");
    return (
        <div className='vehicule-details-container'>
            <div className={`section-serieCode ${LoadingClass}`}>

                <div className='section-form'>
                    <Input
                        label={CONSTANTS.LABELS.vehicule_serial_step1}
                        placeholder={CONSTANTS.LABELS.vehicule_serial_step1_example}
                        onChange={(e) => { setSerieNumberInput(e.target.value) }}
                        errorLabel={serieNumberErrorLabel}
                        Value={serieNumberInput}
                        name='serieNumber'
                    >
                        <div className='section-infos' onClick={dislayVinHelp}>
                            <i className='icons info-icon'></i>
                            <p tabIndex="0" className='info-vin'>{CONSTANTS.LABELS.vehicule_serial_step1_help1}</p>
                            {showInfoDetail && <div ref={myRef} className="info-body">
                                <p tabIndex="0" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_serial_step1_help2) }} />
                                <img src={CONSTANTS.SITE_CONFIG.vinImage} />
                            </div>}
                        </div>
                    </Input>

                    <Input
                        label={CONSTANTS.LABELS.vehicule_step2_km1}
                        // placeholder={'-Enter'}
                        name={'distance'}
                        onChange={(e) => {
                            if (e.target.value.trim().length && (!(/^[0-9]*$/.test(e.target.value)))) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_numbersonly
                                })

                            }
                            else if (e.target.value.trim().length && (Number(e.target.value) > 999999)) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
                                })
                            }
                            else if (e.target.value.trim().length && (Number(e.target.value) === 0)) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_zero
                                })
                            }
                            else {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: ''
                                })
                            }
                        }}
                        errorLabel={kilometrageErrorLabel}
                        Value={kilometrageInput}
                    />
                    <div className='form-group'>
                        <div className='form-input'>
                            <div className='form-label'>
                                <label tabIndex="0">{CONSTANTS.LABELS.vehicule_step2_warranty}</label>
                            </div>
                            <div className='radio-button-group'>
                                <Radio name='servieContract' id='servieContract-0' label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={!contratService} onChange={() => setContratService(false)} />
                                <Radio name='servieContract' id='servieContract-1' label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={contratService} onChange={() => setContratService(true)} />
                            </div>
                        </div>
                    </div>
                    <div className='form-group'>
                        <Button
                            handlClick={() => {
                                checkSerieNumber();
                            }}
                            isDisabled={kilometrageInput.length < 1 || kilometrageErrorLabel.length > 1 || serieNumberInput.length < 1}
                        >
                            {CONSTANTS.LABELS.common_v2_continue}
                        </Button>
                        {/* {isRedirectTo && <Redirect to={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE} />} */}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SerieNumberTab;